import { z } from "zod";
export const publishedDocEnvironments = ["Live", "Preview"];
export const PublishedDocEnvironment = z.enum(publishedDocEnvironments);
export const PublishedDocsChecksums = z.record(z.string());
export const PublishedDocRoutingVersion = z.enum(["1", "2"]);
export const PublishedDoc = z.object({
    id: z.string(),
    designSystemVersionId: z.string(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    lastPublishedAt: z.coerce.date(),
    isDefault: z.boolean(),
    isPublic: z.boolean(),
    environment: PublishedDocEnvironment,
    checksums: PublishedDocsChecksums,
    storagePath: z.string(),
    wasMigrated: z.boolean(),
    routingVersion: PublishedDocRoutingVersion,
    usesLocalizations: z.boolean(),
    wasPublishedWithLocalizations: z.boolean(),
    tokenCount: z.number(),
    assetCount: z.number(),
});
